import React, { useState } from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import SlidingPane from 'react-sliding-pane'
import { useDispatch } from 'react-redux'

import PenaltyForm from './PenaltyForm'
import * as components from '../../components'
import * as rest from '../../services'
import { showErrorToast, showSuccessToast } from '../../state/toasts'
import {PenaltyAmount} from "../../api";



interface PenaltyFormData {
  items: PenaltyAmount[]
}

interface AddLoanerPenaltyPaneProps {
  title: string
  onSubmit: () => void
}

export const AddPenaltyAmountPane: React.FC<AddLoanerPenaltyPaneProps> = ({
  title,
  onSubmit,
}) => {
  const [isPaneOpen, setIsPaneOpen] = useState<boolean>(false)
  const dispatch = useDispatch()

  const createPenaltyItems = (data: PenaltyFormData) => {
    if (!data.items){
        return
    }
    const payload: PenaltyFormData[] = data.items.map((element) => ({
      ...element,
      part_number:data.item_number
    }))

    new rest.PenaltyService()
      .makePostRequest(payload)
      .then(() => {
        onSubmit()
        dispatch(showSuccessToast('Success', 'Loaner Penalty Details Added.'))
      })
      .catch((errors) => {
        console.error(errors)
        const errMessage = errors.response?.data
          ? JSON.stringify(errors.response.data)
          : JSON.stringify(errors)
        dispatch(showErrorToast('Error', errMessage))
      })
  }

  return (
    <>
      <ReactBootstrap.Button
        variant="dark"
        size="sm"
        onClick={() => setIsPaneOpen(true)}
      >
        {components.ICONS.PLUS}
      </ReactBootstrap.Button>

      <SlidingPane
        overlayClassName="on-top"
        isOpen={isPaneOpen}
        title={title}
        onRequestClose={() => setIsPaneOpen(false)}
      >
        <PenaltyForm onSubmit={createPenaltyItems} />
      </SlidingPane>
    </>
  )
}
